<template>
  <v-flex class="white_background full-height" xs12>
    <v-layout class="login-security" row wrap>
      <status-overlay :action="fetchingMLSSettings"></status-overlay>
      <v-flex class="login-security__title" xs12>{{ loginSecurityConstants.LOGIN_SECURITY }}</v-flex>
      <v-flex class="login-security__desc" xs12>{{ loginSecurityConstants.SECURITY_DESCRIPTION }}</v-flex>
      <v-flex class="login-security__note" xs12>
        {{ loginSecurityConstants.SECURITY_NOTE_LABEL + loginSecurityConstants.SECURITY_NOTE }}
      </v-flex>
      <v-layout>
        <v-flex class="login-security__verification" xs12>
          <v-layout class="login-security__verification--header" column>
            <v-flex>{{ loginSecurityConstants.LOGIN_HEADER }}</v-flex>
            <v-flex v-if="showErrorMessageForAmfaUserWithoutSettings"
                    class="login-security__verification--amfa-message">
              {{ loginSecurityConstants.AMFA_ERROR_MSG }}
            </v-flex>
          </v-layout>
          <v-layout v-if="localLoginSecuritySettings && localLoginSecuritySettings.length" column wrap>
            <v-flex v-for="loginSecurity in localLoginSecuritySettings"
                    :key="loginSecurity.key"
                    :data-qe-id="'loginSecurity_' + loginSecurity.key" class="login-security__settings">
              <v-layout class="wrapper" row wrap x12>
                <div class="login-security__settings--desc">
                  <div class="login-security__settings--title">
                    <span>{{ loginSecurity.title }} </span>
                    <span class="login-security__settings--sub-title">{{ loginSecurity.sub_title }} </span>
                  </div>
                  <em>{{ loginSecurity.description }} </em>
                  <span v-if="loginSecurity.sub_description"
                        class="login-security__settings--sub-desc">{{ loginSecurity.sub_description }} </span>
                </div>
                <div class="login-security__settings--btn">
                  <div v-if="!loginSecurity.inEditMode">
                    <v-btn v-if="!loginSecurity.isEnabled"
                           class="primary_btn uppercase small"
                           @click="toggleFactorEdit(loginSecurity.key)">
                      {{ loginSecurityConstants.SETUP }}
                    </v-btn>
                    <v-btn v-if="loginSecurity.isEnabled"
                           class="primary_btn uppercase transparent small"
                           @click="remove(loginSecurity.metadata, loginSecurity.key)">
                      <i class="material-icons">check_circle_outline</i>
                      {{ loginSecurityConstants.REMOVE }}
                    </v-btn>
                  </div>
                  <div v-else>
                    <v-btn class="primary_btn uppercase transparent small"
                           @click="cancelFactorEdit(loginSecurity.key, loginSecurity.isActivationCodeSent)">
                      {{ loginSecurityConstants.CANCEL }}
                    </v-btn>
                  </div>
                </div>
              </v-layout>
              <v-layout v-if="loginSecurity.inEditMode" class="login-security__setup" row wrap x12>
                <v-flex v-if="loginSecurity.key === loginSecurityConstants.FACTOR_SMS">
                  <v-layout class="login-security__content">
                    <v-flex class="login-security__content--text" mb-2>
                      <v-flex :class="[loginSecurity.sendCodeErrorMsg ? 'error--text' : 'inputDescText']" mb-1
                      > {{ loginSecurityConstants.PHONE_NUMBER }}
                      </v-flex>
                      <ypo-phone-number :can-clear="true"
                                        :is-disabled="phoneAlreadyValidated"
                                        :phone="phoneNumber"
                                        :country-code="phoneCountryCode"
                                        :show-example="true"
                                        dataqeid="mfa-setting-phoneCountryCode"
                                        @update="updatePhoneNumber"
                      />
                      <v-flex v-if="loginSecurity.sendCodeErrorMsg" class="error--text" mt-2>
                        {{ loginSecurity.sendCodeErrorMsg }}
                      </v-flex>
                      <v-flex v-if="phoneAlreadyValidated" class="confirm--text" mt-2>
                        {{ loginSecurityConstants.FACTOR_CONFIRMATION_MESSAGE }}
                      </v-flex>
                    </v-flex>
                    <v-flex class="login-security__content--btn">
                      <v-btn v-if="phoneAlreadyValidated" class="primary_btn uppercase small"
                             @click="toggleSetting(loginSecurity.key)">
                        {{ loginSecurityConstants.CONFIRM }}
                      </v-btn>
                      <v-btn v-else :class="[loginSecurity.isActivationCodeSent ? 'resend_btn' : 'primary_btn']"
                             :disabled="isPhoneNumberInvalid"
                             class="uppercase small"
                             @click="sendPhoneCode(loginSecurity, loginSecurity.isActivationCodeSent)">
                        {{
                          loginSecurity.isActivationCodeSent ? loginSecurityConstants.RESEND_CODE : loginSecurityConstants.SEND_CODE
                        }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout v-if="loginSecurity.isActivationCodeSent" class="login-security__content">
                    <v-flex class="login-security__content--text">
                      <span
                          :class="[loginSecurity.confirmAuthenticationErrorMsg ? 'error--text' : 'inputDescText']">{{
                          loginSecurityConstants.AUTHENTICATION_CODE
                        }}</span>
                      <v-text-field
                          v-model="phoneAuthenticationCode"
                          data-qe-id="mfa-setting-phone-authenticationCode"
                          outline
                          single-line
                      >
                      </v-text-field>
                      <v-flex v-if="loginSecurity.confirmAuthenticationErrorMsg" class="error--text" mt-2>
                        {{ loginSecurity.confirmAuthenticationErrorMsg }}
                      </v-flex>
                    </v-flex>
                    <v-flex class="login-security__content--btn">
                      <v-btn class="primary_btn uppercase small"
                             @click="confirmCode(loginSecurity, phoneAuthenticationCode)">
                        {{ loginSecurityConstants.CONFIRM }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex v-if="loginSecurity.key === loginSecurityConstants.FACTOR_EMAIL">
                  <v-layout class="login-security__content">
                    <v-flex class="login-security__content--text">
                      <v-flex :class="[loginSecurity.sendCodeErrorMsg ? 'error--text' : 'inputDescText']" mb-1 xs2>
                        {{ loginSecurityConstants.EMAIL }}
                      </v-flex>
                      <v-text-field
                          v-model="loginSecurity.metadata.profile.email"
                          :placeholder="getUserEmail"
                          class="login-security__text-disabled"
                          data-qe-id="mfa-setting-email"
                          disabled
                          outline
                          readonly
                          single-line
                      >
                      </v-text-field>
                      <v-flex v-if="loginSecurity.sendCodeErrorMsg" class="error--text" mt-2>
                        {{ loginSecurity.sendCodeErrorMsg }}
                      </v-flex>
                    </v-flex>
                    <v-flex class="login-security__content--btn">
                      <v-btn :class="[loginSecurity.isActivationCodeSent ? 'resend_btn' : 'primary_btn']"
                             class="uppercase small"
                             @click="sendEmailCode(loginSecurity, loginSecurity.isActivationCodeSent)">
                        {{
                          loginSecurity.isActivationCodeSent ? loginSecurityConstants.RESEND_CODE : loginSecurityConstants.SEND_CODE
                        }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout v-if="loginSecurity.isActivationCodeSent" class="login-security__content">
                    <v-flex class="login-security__content--text">
                      <v-flex :class="[loginSecurity.confirmAuthenticationErrorMsg ? 'error--text' : 'inputDescText']">
                        {{ loginSecurityConstants.AUTHENTICATION_CODE }}
                      </v-flex>
                      <v-text-field
                          v-model="emailAuthenticationCode"
                          data-qe-id="mfa-setting-email-authenticationCode"
                          outline
                          single-line
                      >
                      </v-text-field>
                      <v-flex v-if="loginSecurity.confirmAuthenticationErrorMsg" class="error--text" mt-2>
                        {{ loginSecurity.confirmAuthenticationErrorMsg }}
                      </v-flex>
                    </v-flex>
                    <v-flex class="login-security__content--btn">
                      <v-btn class="primary_btn uppercase small"
                             @click="confirmCode(loginSecurity, emailAuthenticationCode)">
                        {{ loginSecurityConstants.CONFIRM }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex
                    v-if="loginSecurity.key === loginSecurityConstants.FACTOR_QUESTION && mlsSecurityQuestionsList.length">
                  <v-layout class="login-security__content question">
                    <v-flex class="login-security__content--text question--text" pt-2>
                      <v-flex :class="[loginSecurity.sendCodeErrorMsg ? 'error--text' : 'inputDescText']">
                        {{ loginSecurityConstants.QUESTION }}
                      </v-flex>
                      <v-select
                          id="mfa-setting-questionText"
                          v-model="securityQuestion"
                          :items="mlsSecurityQuestionsList"
                          :placeholder="loginSecurityConstants.QUESTION_PLACEHOLDER"
                          :return-object="true"
                          attach
                          class="login-security__content--selections"
                          item-text="questionText"
                          item-value="question"
                      >
                      </v-select>
                      <v-text-field
                          v-model="loginSecurity.metadata.profile.answer"
                          data-qe-id="mfa-setting-questionText"
                          outline
                          single-line
                      >
                      </v-text-field>
                      <v-flex v-if="loginSecurity.sendCodeErrorMsg" class="error--text" mt-2>
                        {{ loginSecurity.sendCodeErrorMsg }}
                      </v-flex>
                    </v-flex>
                    <v-flex class="login-security__content--btn question--btn">
                      <v-btn class="primary_btn uppercase small"
                             @click="sendQuestionCode(loginSecurity, securityQuestion)">
                        {{ loginSecurityConstants.CONFIRM }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-flex>
</template>
<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { storeAction } from "../../store/storeActions.constant";
import { storeGetters } from "../../store/storeGetters.constant";
import { storeMutation } from "../../store/storeMutations.constant";
import { myAccountConstants, loginSecurityConstants } from "./myaccount.constants.js";
import StatusOverlay from '../StatusOverlay/StatusOverlay';
import YpoPhoneNumber from "@/components/YpoPhoneNumber/YpoPhoneNumber.vue";

export default {
  name: "ManageLoginSecurity",
  data: () => ({
    loginSecurityConstants,
    myAccountConstants,
    localLoginSecuritySettings: [],
    phoneAuthenticationCode: "",
    emailAuthenticationCode: "",
    phoneNumber: '',
    phoneCountryCode: '1',
    isPhoneNumberInvalid: true,
    securityQuestion: {
      questionText: '',
      question: '',
    },
  }),
  components: {
    YpoPhoneNumber,
    StatusOverlay,
  },
  async created() {
    await this.getUserMFASettings();
    await this.getAllSecurityQuestions();
    this.localLoginSecuritySettings = [...this.loginSecuritySettings];
    if (this.mlsSecurityQuestionsList.length) {
      this.localLoginSecuritySettings.forEach((setting) => {
        if (setting.key === this.loginSecurityConstants.FACTOR_QUESTION) {
          // eslint-disable-next-line prefer-destructuring
          this.securityQuestion = this.mlsSecurityQuestionsList[0];
        }
      });
    }
  },
  methods: {
    ...mapActions({
      getUserMFASettings: `manageLoginSecurity/${storeAction.getUserMFASettings}`,
      getAllSecurityQuestions: `manageLoginSecurity/${storeAction.getAllSecurityQuestions}`,
      removeMFASettings: `manageLoginSecurity/${storeAction.removeMFASettings}`,
      saveMFASettings: `manageLoginSecurity/${storeAction.saveMFASettings}`,
      confirmMFASettings: `manageLoginSecurity/${storeAction.confirmMFASettings}`,
      resendMFASettings: `manageLoginSecurity/${storeAction.resendMFASettings}`,
    }),
    ...mapMutations({
      setUserMFASettings: `manageLoginSecurity/${[storeMutation.setUserMFASettings]}`,
      cancelLoginSecurityEdit: `manageLoginSecurity/${[storeMutation.cancelLoginSecurityEdit]}`,
      setPhoneValidated: `manageLoginSecurity/${[storeMutation.setPhoneValidated]}`,
    }),
    updatePhoneNumber(data) {
      this.phoneNumber = data.phone;
      this.phoneCountryCode = data.countryCode;
      this.isPhoneNumberInvalid = data.isInvalid || !this.phoneNumber.length;
    },
    toggleSetting(factorKey) {
      this.localLoginSecuritySettings = this.localLoginSecuritySettings.map(setting => ({
        ...setting,
        inEditMode: setting.key === factorKey ? !setting.inEditMode : false,
      }));
      this.setPhoneValidated(false);
    },
    async toggleFactorEdit(factorKey) {
      const settingWithPendingActivation = this.localLoginSecuritySettings.find(setting => setting && setting.isActivationCodeSent);
      if (settingWithPendingActivation) {
        await this.removeMFASettings(settingWithPendingActivation.metadata);
      } else if (this.phoneAlreadyValidated) {
        const smsNotConfirmed = this.localLoginSecuritySettings.find(setting => setting && setting.factorType === this.loginSecurityConstants.FACTOR_SMS);
        await this.removeMFASettings(smsNotConfirmed.metadata);
      } else {
        this.toggleSetting(factorKey);
      }
      this.clearLocalSecurity(factorKey);
    },
    clearLocalSecurity(factorKey) {
      if (factorKey === this.loginSecurityConstants.FACTOR_SMS) {
        const phoneSettings = this.localLoginSecuritySettings.find(mfaSetting => mfaSetting.factorType === factorKey);
        this.phoneNumber = '';
        this.phoneAuthenticationCode = '';
        phoneSettings.sendCodeErrorMsg = '';
      }
      if (factorKey === this.loginSecurityConstants.FACTOR_EMAIL) {
        const emailSettings = this.localLoginSecuritySettings.find(mfaSetting => mfaSetting.factorType === factorKey);
        emailSettings.metadata.profile.email = '';
        emailSettings.sendCodeErrorMsg = '';
        this.emailAuthenticationCode = '';
      }
      if (factorKey === this.loginSecurityConstants.FACTOR_QUESTION) {
        const questionLocalSettings = this.localLoginSecuritySettings.find(mfaSetting => mfaSetting.factorType === factorKey);
        questionLocalSettings.metadata.profile.answer = '';
        questionLocalSettings.metadata.profile.question = '';
        questionLocalSettings.metadata.profile.questionText = '';
        questionLocalSettings.sendCodeErrorMsg = '';
        // eslint-disable-next-line prefer-destructuring
        this.securityQuestion = this.mlsSecurityQuestionsList[0];
      }
    },
    cancelFactorEdit(factorKey, isActivationCodeSent) {
      if (isActivationCodeSent || (factorKey === this.loginSecurityConstants.FACTOR_SMS && this.phoneAlreadyValidated)) {
        const mlsSettings = this.localLoginSecuritySettings.find(mfaSetting => mfaSetting.factorType === factorKey);
        this.removeMFASettings(mlsSettings.metadata);
      } else {
        this.toggleFactorEdit(factorKey);
        this.clearLocalSecurity(factorKey);
        this.cancelLoginSecurityEdit(factorKey);
      }
    },
    async remove(factorSetting, factorKey) {
      const settingWithPendingActivation = this.localLoginSecuritySettings.find(setting => setting && setting.isActivationCodeSent);
      if (settingWithPendingActivation) {
        await this.removeMFASettings(settingWithPendingActivation.metadata);
      }
      if (this.phoneAlreadyValidated) {
        const smsNotConfirmed = this.localLoginSecuritySettings.find(setting => setting && setting.factorType === this.loginSecurityConstants.FACTOR_SMS);
        await this.removeMFASettings(smsNotConfirmed.metadata);
      }
      await this.removeMFASettings(factorSetting);
      this.clearLocalSecurity(factorKey);
    },
    async sendPhoneCode(loginFactor, isActivationCodeSent) {
      const phoneSettings = this.localLoginSecuritySettings.find(mfaSetting => mfaSetting.factorType === loginFactor.factorType);
      const saveData = {
        profile: {
          phoneNumber: this.phoneNumber.length ? `+${this.phoneCountryCode}${this.phoneNumber}` : loginFactor.metadata.profile.phoneNumber,
        },
        factorType: this.loginSecurityConstants.FACTOR_SMS,
        provider: this.loginSecurityConstants.PROVIDER,
      };
      if (loginFactor.metadata.id) {
        saveData.id = loginFactor.metadata.id;
      }
      try {
        if (isActivationCodeSent) {
          await this.resendMFASettings(saveData);
        } else {
          await this.saveMFASettings(saveData);
        }
        phoneSettings.isActivationCodeSent = true;
      } catch (error) {
        phoneSettings.sendCodeErrorMsg = error;
      }
    },
    async sendEmailCode(loginFactor, isActivationCodeSent) {
      const emailSettings = this.localLoginSecuritySettings.find(mfaSetting => mfaSetting.factorType === loginFactor.factorType);
      const saveData = {
        profile: {email: this.getUserEmail},
        factorType: this.loginSecurityConstants.FACTOR_EMAIL,
        provider: this.loginSecurityConstants.PROVIDER,
      };
      if (loginFactor.metadata.id) {
        saveData.id = loginFactor.metadata.id;
      }
      try {
        if (isActivationCodeSent) {
          await this.resendMFASettings(saveData);
        } else {
          await this.saveMFASettings(saveData);
        }
        emailSettings.isActivationCodeSent = true;
      } catch (error) {
        emailSettings.sendCodeErrorMsg = error;
      }
    },
    async sendQuestionCode(loginFactor) {
      const questionSettings = this.localLoginSecuritySettings.find(mfaSetting => mfaSetting.factorType === loginFactor.factorType);
      const saveData = {
        profile: {
          questionText: this.securityQuestion ? this.securityQuestion.questionText : '',
          question: this.securityQuestion ? this.securityQuestion.question : '',
          answer: loginFactor.metadata.profile.answer,
        },
        factorType: this.loginSecurityConstants.FACTOR_QUESTION,
        provider: this.loginSecurityConstants.PROVIDER,
      };
      if (loginFactor.metadata.id) {
        saveData.id = loginFactor.metadata.id;
      }
      try {
        await this.saveMFASettings(saveData);
      } catch (error) {
        questionSettings.sendCodeErrorMsg = error;
      }
    },
    async confirmCode(loginSecurity, code) {
      const mlsSettings = this.localLoginSecuritySettings.find(mfaSetting => mfaSetting.factorType === loginSecurity.factorType);
      const saveData = {
        id: loginSecurity.metadata.id,
        passCode: code,
      };
      try {
        await this.confirmMFASettings(saveData);
      } catch (err) {
        mlsSettings.confirmAuthenticationErrorMsg = err;
      }
    },
  },
  computed: {
    ...mapState('actionState', ['actions']),
    ...mapGetters({
      userMFASettings: `manageLoginSecurity/${storeGetters.userMFASettings}`,
      loginSecuritySettings: `manageLoginSecurity/${storeGetters.loginSecuritySettings}`,
      isUserInAmfaGroup: `manageLoginSecurity/${storeGetters.isUserInAmfaGroup}`,
      securityQuestionsList: `manageLoginSecurity/${storeGetters.securityQuestionsList}`,
      getPhoneConfirmation: `manageLoginSecurity/${storeGetters.getPhoneConfirmation}`,
      userInfo: `manageLoginSecurity/${storeGetters.userInfo}`,
    }),
    mlsSecurityQuestionsList() {
      return this.securityQuestionsList ? this.securityQuestionsList : [];
    },
    fetchingMLSSettings() {
      return this.actions[(storeAction.getUserMFASettings && storeAction.removeMFASettings) || storeAction.saveMFASettings
      || storeAction.removeMFASettings || storeAction.confirmMFASettings || storeAction.resendMFASettings];
    },
    getUserEmail() {
      return this.userInfo ? this.userInfo.email : '';
    },
    phoneAlreadyValidated() {
      return this.getPhoneConfirmation;
    },
    showErrorMessageForAmfaUserWithoutSettings() {
      return !this.userMFASettings.length && this.isUserInAmfaGroup;
    },
  },
  watch: {
    loginSecuritySettings() {
      this.localLoginSecuritySettings = [...this.loginSecuritySettings];
      if (this.mlsSecurityQuestionsList.length) {
        this.localLoginSecuritySettings.forEach((setting) => {
          if (setting.key === this.loginSecurityConstants.FACTOR_QUESTION) {
            // eslint-disable-next-line prefer-destructuring
            this.securityQuestion = this.mlsSecurityQuestionsList[0];
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../common/styles/_colors.scss";
@import "../../common/styles/_responsive.scss";

.login-security {
  position: relative;
  padding: 0 45px;
  margin: 0 auto;
  max-width: 1000px;
  top: 64px;

  @include breakpointMin(xs) {
    padding: 0 24px;
  }

  @include breakpointMin(sm) {
    padding: 0 45px;
  }

  .primary_btn {
    i {

      color: $ypo-medium-green;
      @include breakpointMin(xs) {
        padding-right: 5px;
        font-size: 18px;
      }

      @include breakpointMin(sm) {
        padding-right: 8px;
        font-size: 20px;
      }
    }

    @include breakpointMin(xs) {
      padding: 5px 14px;
      font-size: 13px;
    }

    @include breakpointMin(sm) {
      padding: 5px 18px;
      font-size: 14px;
    }
  }

  &__title {
    background-color: $white;
    color: $ypo-blue;
    font-family: 'Raleway', sans-serif;
    font-size: 30px;
    font-weight: 500;
    padding: 20px 10px 0 0;
  }

  &__desc {
    background-color: $white;
    color: $ypo-blue;
    font-family: 'Raleway', sans-serif;
    font-size: 14px;
    font-weight: 500;
    padding: 20px 10px 0 0;
  }

  &__note {
    font-family: 'Raleway', sans-serif;
    font-size: 12px;
    font-weight: 600;
    padding: 10px 0 0 0;
  }

  &__verification {
    margin-top: 25px;
    border: 1px solid $ypo-extra-light-gray;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba($black, 0.5);
    margin-bottom: 85px;

    &--header {
      color: $ypo-blue;
      font-family: 'Raleway', sans-serif;
      font-size: 16px;
      font-weight: 500;
      padding: 12px;
      border-bottom: 1px solid rgba($ypo-gray, 0.4);
      line-height: 28px;
    }

    &--amfa-message {
      color: $ypo-error-red;
      font-size: 15px;
      font-weight: 600;
    }
  }

  &__settings {
    border-bottom: 1px solid rgba($ypo-gray, 0.4);

    &:last-child {
      border-bottom: none;
    }

    &--btn {
      padding: 12px;

      @include breakpointMin(xs) {
        padding: 18px 0 0 0;
      }

      @include breakpointMin(sm) {
        padding: 12px;
      }
    }

    &--desc {
      font-family: 'Raleway', sans-serif;
      font-size: 14px;
      font-weight: 600;
      padding: 12px;

      @include breakpointMin(xs) {
        padding: 12px 6px 6px 12px;
        max-width: 59%;
      }

      @include breakpointMin(sm) {
        padding: 12px 6px 6px 12px;
        max-width: 65%;
      }

      span {
        display: flex;
      }

      em {
        font-size: 12px;
        font-weight: 500;
        font-style: normal;
      }
    }

    &--title {
      @include breakpointMin(xs) {
        display: block;
      }
      @include breakpointMin(sm) {
        display: -webkit-box;
      }
    }

    &--sub-title {
      font-family: 'Raleway', sans-serif;
      font-size: 12px;
      font-weight: 600;
      padding-left: 6px;

      @include breakpointMin(xs) {
        padding-left: 0;
        display: block;
      }
      @include breakpointMin(sm) {
        padding-left: 6px;
        display: flex;
        line-height: 22px;
      }
      @include breakpointMin(md) {
        padding-left: 6px;
        display: flex;
        line-height: 22px;
      }
    }

    &--sub-desc {
      color: $ypo_cta;
      font-size: 12px;
      font-weight: 500;
      font-style: normal;
    }
  }

  &__content {
    padding-left: 48px;
    justify-content: space-between;
    @include breakpointMin(xs) {
      padding-left: 12px;
    }

    @include breakpointMin(sm) {
      padding-left: 48px;
    }

    &--text {
      font-family: 'Raleway', sans-serif;
      padding-left: 24px;
      padding-bottom: 12px;
      @include breakpointMin(xs) {
        padding-left: 0;
        max-width: 60%;
      }
      @include breakpointMin(sm) {
        padding-left: 24px;
        max-width: 50%;
      }
    }

    &--btn {
      padding-top: 24px;
      padding-left: 24px;
      text-align: end;
      @include breakpointMin(xs) {
        padding-top: 16px;
        padding-left: 0;
      }

      @include breakpointMin(sm) {
        padding-left: 24px;
        padding-right: 12px;
      }
    }

    &--selections {
      padding-bottom: 12px;
      padding-top: 0;
    }
  }

  .question {
    @include breakpointMin(xs) {
      flex-direction: column;
    }

    @include breakpointMin(sm) {
      flex-direction: row;
    }

    &--text {
      @include breakpointMin(xs) {
        max-width: 286px;
      }

      @include breakpointMin(sm) {
        max-width: 50%;
      }
    }

    &--btn {
      @include breakpointMin(xs) {
        padding-top: 0;
        padding-bottom: 20px;
        text-align: center;
      }

      @include breakpointMin(sm) {
        padding-top: 16px;
        padding-bottom: 0;
        text-align: end;
      }
    }
  }

  .wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .resend_btn {
    border: 2px solid $ypo-blue;
    color: $ypo-blue !important;
    border-radius: 4px;
    background: none !important;
    padding: 5px 18px;
    min-width: inherit;
    height: auto;
    font-size: 14px;
    font-weight: 600;
    box-shadow: none !important;
  }

  .error--text {
    color: $ypo-error-red;
    font-family: 'Raleway', sans-serif;
    font-size: 12px;
    font-weight: 600;
  }

  .confirm--text {
    color: $ypo-medium-green;
    font-family: 'Raleway', sans-serif;
    font-size: 12px;
    font-weight: 600;
  }

  .inputDescText {
    font-size: 12px;
    font-weight: 500;
    font-style: normal;
  }

  .loading-settings {
    position: relative;
    height: 150px;
  }
}
</style>

<style lang="scss">
@import '../../common/styles/_responsive.scss';
@import "../../common/styles/_colors.scss";

.login-security {
  .v-text-field__details {
    display: none;
  }

  .v-input__slot {
    min-height: 35px !important;
    max-height: 40px !important;
  }

  &__text-disabled {
    .v-input__slot {
      border: 2px solid $ypo-medium-gray !important;
    }
  }

  .v-text-field--outline.v-text-field--single-line input {
    margin-top: 6px;
  }

  .v-select__selections {
    font-size: 13px;
  }

  .v-text-field__slot {
    font-size: 14px;
  }

  .v-select__selection--comma {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: inline-block;
    font-size: 13px;
    padding-left: 8px;
    @include breakpointMin(xs) {
      max-width: 251px;
    }

    @include breakpointMin(sm) {
      max-width: 371px;
    }
  }

  .v-menu__content {
    min-width: 250px;
    max-width: 306px;
    @include breakpointMin(xs) {
      top: -108px !important;
    }

    @include breakpointMin(sm) {
      top: 0 !important;
    }

    .v-list {
      & > div {
        .v-list__tile {
          @include breakpointMin(xs) {
            height: 56px;
          }

          @include breakpointMin(sm) {
            height: 48px;
          }
        }

        .v-list__tile__title, .v-list__tile__sub-title {
          white-space: normal !important;
          overflow: unset !important;
          text-overflow: unset !important;
          font-size: 13px;
          height: auto;
          min-height: 24px;
          max-height: 36px;
        }
      }
    }
  }
}

</style>
